import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_CONTENT } from "../content/defaults";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContentContext = createContext({ c: DEFAULT_CONTENT, loading: true, refresh: () => {} });

function isObj(v) {
  return v && typeof v === "object" && !Array.isArray(v);
}

// Deep-merge server content over defaults so missing fields always resolve.
function deepMerge(base, override) {
  if (!isObj(base) || !isObj(override)) return override === undefined ? base : override;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    if (isObj(base[key]) && isObj(override[key])) {
      out[key] = deepMerge(base[key], override[key]);
    } else if (override[key] !== undefined && override[key] !== null) {
      out[key] = override[key];
    }
  }
  return out;
}

// Resolve image URLs that may be stored as /api/media/xxx
export function mediaUrl(url) {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}

export function ContentProvider({ children }) {
  const [c, setC] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const res = await axios.get(`${API}/content`);
      setC(deepMerge(DEFAULT_CONTENT, res.data || {}));
    } catch (e) {
      setC(DEFAULT_CONTENT);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ c, loading, refresh, setC }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
